import axios from "axios";

class DocumentGeneratorService {
    constructor() {
        this.baseURL = "/document-generator";
    }

    generateRoamingInvoiceSendHashCode(payload) {
        return axios.post(`${this.baseURL}/roaming/invoice/generate/send-hash-code`, payload);
    }
}

const documentGeneratorService = new DocumentGeneratorService();
export default documentGeneratorService;
